import { gql } from '@apollo/client'

export const KitchenConfigurationOptionFragment = gql`
  fragment KitchenConfigurationOption on KitchenConfigurationOption {
    cost
    type
    value
  }
`

export const KitchenConfigurationFragment = gql`
  ${KitchenConfigurationOptionFragment}
  fragment KitchenConfiguration on KitchenConfiguration {
    id
    configurationNumber
    configurationUrl
    createdAt
    currency
    imageUrl
    kitchenConfigurationOptions {
      ...KitchenConfigurationOption
    }
    kitchenRangeName
    pageUrl
    totalPrice
    updatedAt
  }
`
